import Plaatjie from "@ubo/plaatjie"
import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import styled from "styled-components"
import ParseContent from "components/shared/ParseContent"
import { getLanguage } from "services/language"


const Box = styled.div`
  background-color: ${props => props.theme.color.contrast};
  border-radius: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 3rem;

  & span {
    color: ${props => props.theme.color.text.light};
    font-weight: 300;
  }

  @media (max-width: 991px){
    padding: 1rem 1rem 2rem;
  }
`

const Content = styled(ParseContent)`
  & h2 {
    color: ${props => props.theme.color.text.light};
    font-weight: 800;

    
    @media (max-width: 1198px) {
      font-size: 30px !important;
    }

    @media (min-width: 1199px){
      font-size: 50px;
      line-height: 69px;
    }
    
  }

  & p {
    color: ${props => props.theme.color.text.light};
    font-size: 16px;
    line-height: 30px;
  }
`

const Column = styled.div`
  @media (max-width: 991px){
    max-height: 300px;
  }
`

const StyledButton = styled.a`
  background-color: ${props => props.theme.color.secondary};
  border: 2px solid ${props => props.theme.color.secondary};
  display: inline-flex;
  border-radius: 30px;
  font-weight: ${props => props.theme.font.weight.l};
  color: ${props => props.theme.color.text.light};  

  & > svg {
    margin-left: 15px;

    @media (min-width: 992px) {
      height: 25px;
      width: 25px;
    }

    @media (max-width: 991px) {
      height: 20px;
      width: 20px;
    }
  }

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.color.light};
    border-color: ${props => props.theme.color.light};
    color: ${props => props.theme.color.text.secondary};  
  }

  @media (min-width: 992px) {
    font-size: ${props => props.small ? props.theme.font.size.m : props.theme.font.size.xm};
    padding: 12px 65px;
  }

  @media (max-width: 991px) {
    font-size: ${props => props.small ? props.theme.font.size.m : props.theme.font.size.m};
    padding: 10px 25px;
  }
`

const CTA = () => { 
  return (
    <section>
      <div className="container my-5">
        <div className="col-lg-12">
          <Box>
            
            <div className="col-lg-8">
              <Content content='<h2>Klaar voor uw internationale verhuizing?</h2>' />
              
              <Content content='<p>Of u nu binnen Europa verhuist of naar een bestemming aan de andere kant van de wereld, wij begeleiden u tijdens iedere stap van uw verhuizing.</p>' className="pr-5 mb-4" />
              <StyledButton href='/offerte-aanvragen/' target="_blank" rel="noopener noreferrer" className="justify-content-center text-center">vraag een prijsindicatie aan</StyledButton>
            </div>
          </Box>
        </div>
      </div>
    </section>
  )
}

export default CTA